/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBeaker = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 2v2h-2v2.591c1.334 1.374 6 6.393 6 9.41v2c0 2.205-1.794 4-4 4H7c-2.206 0-4-1.795-4-4v-2c0-3.017 4.666-8.036 6-9.41V4H7V2zm-4 2h-2v3.414l-.293.293C8.5 9.915 5 14.12 5 16v2c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-2c0-1.884-3.5-6.086-5.707-8.293L13 7.414zm3 12v2H8v-2zm-1-4v2h-2v-2zm-3-2v2h-2v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBeaker as Beaker };
